import { render } from "./ProspectFirmologyAlt.vue?vue&type=template&id=77706bb0"
import script from "./ProspectFirmologyAlt.vue?vue&type=script&lang=js"
export * from "./ProspectFirmologyAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__